var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHashnode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.1 5.347c-1.466 1.438-1.466 3.84 0 5.306L5.346 14.9c1.437 1.466 3.84 1.466 5.306 0l4.247-4.247c1.465-1.465 1.465-3.868 0-5.306L10.653 1.1C9.187-.366 6.784-.366 5.347 1.1L1.099 5.347ZM9.86 9.86a2.63 2.63 0 0 1-3.716 0 2.624 2.624 0 0 1 0-3.716 2.624 2.624 0 0 1 3.715 0 2.63 2.63 0 0 1 0 3.716Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHashnode);
export default __webpack_public_path__ + "static/media/icon-hashnode.b74159c209bba7209d11dc1dbe84c3f6.svg";
export { ForwardRef as ReactComponent };